import { useEffect } from 'react'
import { useSessionStore } from '../contexts/SessionStore'
import { AUTH_EXPIRED_EVENT, PLANNING_REAUTH_SUCCESS } from '../services/ReauthService'

export const useSessionEvents = () => {
  useEffect(() => {
    const handleAuthExpired = (event) => {
      useSessionStore.getState().markExpired({
        message: event.detail?.message || 'Session expirée',
      })
    }

    const handleReauthSuccess = (event) => {
      if (event.origin !== window.location.origin) return
      if (event.data?.type !== PLANNING_REAUTH_SUCCESS) return

      useSessionStore.getState().completeReauthentication(event.data.user)
    }

    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired)
    window.addEventListener('message', handleReauthSuccess)

    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired)
      window.removeEventListener('message', handleReauthSuccess)
    }
  }, [])
}
